import App from './App'
import AppChameleon from './AppChameleon'
import Auth from './Auth'

export default {
  App,
  AppChameleon,
  Auth
}
